import React from 'react'
import FilterComponent from './FilterComponent'
import { result, debounce } from 'libraries/lodash'
import cx from 'classnames'

const UPDATE_DELAY = 300

export default class TextFilter extends FilterComponent {
  state = { value: this.value }
  isTyping = false
  pendingValue

  get value () {
    return result(this.props.filterValue, '0.value.0', '')
  }

  componentDidUpdate () {
    // Only resync local state from props once typing has settled - the URL
    // push (and the async round-trip that eventually reflects it back
    // through props) is debounced, and isTyping/pendingValue track that
    // debounce plus the in-flight round-trip (this build's lodash/debounce
    // doesn't expose .pending() to check directly). Resyncing unconditionally
    // used to race an in-flight props update against whatever the user had
    // typed since, silently dropping characters (confirmed live: typing
    // "Sparqa" quickly left only "a" in the field and sent to the backend).
    if (this.pendingValue !== undefined && this.value === this.pendingValue) {
      this.pendingValue = undefined
    }
    if (!this.isTyping && this.pendingValue === undefined && this.value !== this.state.value) {
      this.setState({ value: this.value })
    }
  }

  componentWillUnmount () {
    this.debouncedUpdate.cancel()
  }

  debouncedUpdate = debounce((value) => {
    this.isTyping = false
    this.pendingValue = value
    this.props.setFilterValue([
      [[value], '≈']
    ])
  }, UPDATE_DELAY)

  handleChange = (e) => {
    const value = e.target.value
    this.isTyping = true
    this.setState({ value })
    this.debouncedUpdate(value)
  }

  render () {
    const { basicDisplay } = this.props

    return (
      <div className='flex justify-end placeholder-cadet-blue-important w-100'>
        <input
          type='text'
          className={cx('pv2 ph3 bg-transparent ba mv2 mh0', {
            w13: basicDisplay,
            'w-100': !basicDisplay
          })}
          onChange={this.handleChange}
          value={this.state.value}
          placeholder='Search'
        />
      </div>
    )
  }
}
